import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthenticationType, OidcFactory } from 'src/app/services/oidc.factory';
import { CognitoService } from 'src/app/services/cognito.service';
import { SessionService } from 'src/app/services/session.service';
import { PlatformApiService } from 'src/app/services/platform-api.service';

@Component({
  selector: 'cw-ci-sso-match',
  templateUrl: './sso-match.component.html',
  styleUrls: ['./auth.layout.scss']
})
export class SsoMatchComponent implements OnInit {
  loginForm = new FormGroup ({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required])
  });

  @Input() idToken;
  @Output() stateChange: EventEmitter<any> = new EventEmitter();

  constructor(private _cognitoService: CognitoService, private _sessionService: SessionService, private _platformApi: PlatformApiService, private _oidcFactory: OidcFactory) { }

  ngOnInit() {
  }

  onConnect() {
    console.log(this.loginForm);
    this.loginForm.updateValueAndValidity();
    if (this.loginForm.valid) {
      this._sessionService.logout();
      this._cognitoService.authenticate(this.loginForm.value.email, this.loginForm.value.password).then(
        success => {
          if (success == 'SUCCESS') {
            this.linkAccount();
          } else if (success.status == 'MFAREQUIRED') {
            this.stateChange.emit({state:'MFAREQUIRED', mfaType: success.mfaType, cognitoUser: success.cognitoUser, linkAccountCallback: this.linkAccount});
          } else {
            this.loginForm.setErrors({invalidUser: true});
          }
        },
        error => {
          this.loginForm.setErrors({invalidUser: true});
        });
    }
  }

  linkAccount() {
    this._sessionService.setAuthenticationType(AuthenticationType.COGNITO);
    this._platformApi.linkSsoToAllAccounts(this.idToken).subscribe(() => {
      const oidcService = this._oidcFactory.getOidcService(AuthenticationType.SSOJWT);
      oidcService.getManager().signinRedirect();
    });
  }

  onCancel() {
    this.stateChange.emit({state:'LOGIN'});
  }
}
